<template>
  <v-layout>
    <v-flex xs12>
      <h1 v-if="id == ''" class="headline">Group Template Builder</h1>
      <h1 v-else class="headline">{{ editLabel }}</h1>
      <v-stepper v-model="step" non-linear>
        <v-stepper-header>
          <v-stepper-step :complete="step > 1" step="1" editable
            >Details</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step
            :complete="step > 2"
            step="2"
            :editable="validateFirstStep"
            >Services</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step
            :complete="step > 3"
            step="3"
            :editable="validateFirstStep"
            >Increments</v-stepper-step
          >
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-container fluid grid-list-xs>
              <v-layout row wrap fill-height>
                <v-flex xs12 sm4 class="px-1">
                  <v-text-field
                    v-model="name"
                    label="Template Name"
                    :outlined="outlinedInputs"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 class="px-1">
                  <destination-list-select
                    :destination="destination"
                    :set-default="true"
                    :outlined="outlinedInputs"
                    @onSelect="onDestinationSelect($event)"
                  ></destination-list-select>
                </v-flex>
                <v-flex xs12 sm3 class="px-1">
                  <department-list v-model="department"></department-list>
                </v-flex>
                <v-flex xs12 sm2 class="px-1">
                  <v-select
                    label="Duration(Days)"
                    :items="days"
                    v-model="duration"
                    :outlined="outlinedInputs"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12>
                  <v-textarea
                    label="Short Description"
                    v-model="description"
                    :outlined="outlinedInputs"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
            <v-btn
              color="primary"
              text
              :disabled="!validateFirstStep"
              @click="firstStepContinue"
            >
              Continue To Services
              <v-icon right small>mdi-arrow-right</v-icon>
            </v-btn>
          </v-stepper-content>
          <v-stepper-content step="2" class="py-0">
            <v-container fluid py-0>
              <v-row justify="end"
                ><v-switch
                  label="Drag &amp; Drop"
                  v-model="dayByDay"
                  dense
                  hide-details
                ></v-switch
              ></v-row>
            </v-container>
            <template-builder-day-by-day
              :destination-id="destination ? destination.id : ''"
              :duration="duration"
              :items="items"
              @update-item="onUpdateItem"
              @add-item="onAddItem"
              @remove-item="onRemoveItem"
              v-if="dayByDay"
            ></template-builder-day-by-day>
            <template v-else>
              <template-builder-item-quick-add
                @onAddItem="onAddItem"
                :destinationId="destinationId"
                :template-duration="duration"
              ></template-builder-item-quick-add>
              <template-builder-items-list
                :items="items"
                @updateItem="onUpdateItem"
                :duration="duration"
              ></template-builder-items-list>
            </template>
            <v-btn
              color="primary"
              text
              :disabled="!validateFirstStep"
              @click="step = 3"
            >
              Continue To Departure Dates
              <v-icon right small>mdi-arrow-right</v-icon>
            </v-btn>
          </v-stepper-content>

          <v-stepper-content step="3">
            <increments
              :department="department"
              :destination="destination ? destination.id : ''"
              :template-id="id"
              :template-items="items"
              :departures="departures"
              :duration="duration"
            ></increments>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
      <v-layout justify-center pa-3>
        <v-btn
          color="primary"
          @click="onSave"
          :disabled="loading || !validateFirstStep"
          >{{ saveLabel }}</v-btn
        >
      </v-layout>

      <v-progress-linear
        :indeterminate="true"
        v-show="$apollo.loading || loading"
      ></v-progress-linear>

      <div v-if="debug">
        <code>template items: {{ items }}</code>
      </div>
    </v-flex>
    <back-to-list-btn route="/templates"></back-to-list-btn>
  </v-layout>
</template>
<script>
import DestinationListSelect from "../../shared/DestinationListSelect";
import DepartmentList from "../../shared/DepartmentListSelect";
import TemplateBuilderItemsList from "./TemplateBuilderItemsList";
import TemplateBuilderItemQuickAdd from "./TemplateBuilderItemQuickAdd";
import TemplateDepartureDates from "./TemplateDepartureDates";

import BackToListBtn from "../../shared/BackToListBtn";
import TemplateBuilderDayByDay from "./TemplateBuilderDayByDay";

import {
  TEMPLATE_CREATE_MUTATION,
  TEMPLATE_UPDATE_MUTATION,
  TEMPLATE_RECORD_QUERY,
  TEMPLATE_ITEM_UPDATE_MUTATION,
} from "../../../../constants/graphql";
import { removeGQLTypename, sortBy } from "../../../../helpers";
import Increments from "./increments/Increments.vue";

const randomize = require("randomatic");
export default {
  name: "GroupTemplateBuilder",
  components: {
    DestinationListSelect,
    DepartmentList,
    TemplateBuilderItemsList,
    TemplateBuilderItemQuickAdd,
    BackToListBtn,

    TemplateBuilderDayByDay,

    Increments,
  },
  data() {
    return {
      debug: false,
      dayByDay: true,
      loading: false, //used for create/update mutation
      id: this.$route.params.id || "",
      step: 1,
      department: "FIT",
      name: "",
      destination: null,
      items: [],
      skipLoad: true,
      duration: 7,
      description: "",
      days: [...Array(30).keys()].map((x) => (x = x + 1)),
      departures: [],
      slabs: [],
    };
  },
  methods: {
    onDestinationSelect($event) {
      this.destination = $event;
    },
    onDepartmentSelect($event) {
      this.department = $event.name;
    },
    firstStepContinue() {
      this.step = 2;
    },
    onAddItem(payload) {
      this.items.push(payload);
    },
    onSave() {
      this.saveTemplate();
    },
    saveTemplate() {
      this.loading = true;
      let update = this.id != "";
      let mutation = update
        ? TEMPLATE_UPDATE_MUTATION
        : TEMPLATE_CREATE_MUTATION;
      const vars = {
        input: {
          name: this.name,
          destinationId: this.destination.id,
          department: this.department,
          items: this.items.map(this.toTemplateInputItem),
          description: this.description,
          duration: this.duration,
          slabs: [...this.slabs],
          type: "GROUP",
        },
      };
      if (update) {
        vars.id = this.id;
      }
      this.$apollo
        .mutate({
          mutation: mutation,
          variables: vars,
        })
        .then(this.saveTemplateHandler, this.saveTemplateErrorHandler);
    },
    saveTemplateHandler(result) {
      this.loading = false;
      if (result.data.hasOwnProperty("createTemplate")) {
        this.id = result.data.createTemplate.id;
        this.$router.push("/group-template/" + this.id + "/edit");
      }
      this.$store.dispatch("showAppSnackbar", { msg: "Template saved." });
    },
    saveTemplateErrorHandler(error) {
      this.loading = false;
      console.log(error);
    },
    toTemplateInputItem(item) {
      const templateInputItem = {
        serviceId: item.serviceId,
        uid: item.uid,
        day: Number(item.day),
        order: Number(item.order),
        duration: Number(item.duration),
        itemBuy: item.itemBuy,
        itemSell: item.itemSell,
        adultBuy: item.adultBuy,
        adultSell: item.adultSell,
        childBuy: item.childBuy,
        childSell: item.childSell,
        currencyBuy: item.currencyBuy,
        currencySell: item.currencySell,
        rateTypeCode: item.rateTypeCode,
        totalSell: item.totalSell,
        totalBuy: item.totalBuy,
        customPricing: item.customPricing,
        extras:
          item.extras && item.extras.length > 0
            ? [
                ...item.extras.map((e) => ({
                  ...e,
                  day: Number(e.day),
                  duration: Number(e.duration),
                })),
              ]
            : [],
      };
      //console.log(templateInputItem)
      return templateInputItem;
    },
    fromTemplateItem(node) {
      let item = node.node;
      return {
        id: item.id,
        uid: item.uid ? item.uid : randomize("Aa0", 32),
        serviceType: item.supplier.serviceType,
        serviceName: item.service.name,
        stdOccupancy: item.service.stdOccupancy,
        maxOccupancy: item.service.maxOccupancy,
        serviceId: item.service.id,
        supplierId: item.supplier.id,
        supplierName: item.supplier.name,
        day: item.day,
        order: item.order,
        duration: item.duration,
        itemBuy: item.itemBuy,
        itemSell: item.itemSell,
        adultBuy: item.adultBuy,
        adultSell: item.adultSell,
        childBuy: item.childBuy,
        childSell: item.childSell,
        currencyBuy: item.currencyBuy,
        currencySell: item.currencySell,
        rateTypeCode: item.rateTypeCode,
        customPricing: item.customPricing,
        extras:
          item.extras.edges && item.extras.edges.length > 0
            ? [...item.extras.edges.map(removeGQLTypename)]
            : [],
      };
    },
    onRemoveItem(payload) {
      const index = this.items.findIndex((item) => item.uid == payload.uid);
      if (index > -1) {
        this.items.splice(index, 1);
      }
    },
    onUpdateItem(item) {
      this.items = [...this.items.filter((i) => i.uid != item.uid), item];
      // const input = this.toTemplateInputItem(item);
      // try {
      //   const result = await this.$apollo.mutate({
      //     mutation: TEMPLATE_ITEM_UPDATE_MUTATION,
      //     variables: {
      //       id: item.id,
      //       input
      //     },
      //     refetchQueries: [
      //       { query: TEMPLATE_RECORD_QUERY, variables: { id: this.id } }
      //     ]
      //   });
      //   this.$store.dispatch("showAppSnackbar", {
      //     msg: "Item updated"
      //   });
      //   //console.log(result);
      // } catch (error) {
      //   console.log(error);
      // }
    },
  },
  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    validateFirstStep: function () {
      let valid = true;
      valid = this.destination && this.name != "";
      return valid;
    },
    editLabel: function () {
      let durationLabel = this.duration > 1 ? "days" : "day";
      return `${this.name} / ${
        this.destination ? this.destination.name : ""
      } / ${this.duration} ${durationLabel}`;
    },
    saveLabel: function () {
      return this.$route.params.id
        ? "Update Group Template"
        : "Create Group Template";
    },
    destinationId: function () {
      return this.destination ? this.destination.id : null;
    },
  },
  apollo: {
    template: {
      query: TEMPLATE_RECORD_QUERY,
      variables() {
        return {
          id: this.id,
        };
      },
      result({ data, loader, networkStatus }) {
        //this.setupFromData(data);
        this.destination = Object.assign({}, data.template.destination);
        this.department = data.template.department;
        this.name = data.template.name;
        this.items = data.template.items.edges
          .map(this.fromTemplateItem)
          .sort(sortBy("order"));
        this.description = data.template.description;
        this.duration = data.template.duration;
        this.departures =
          data.template.departures.edges &&
          data.template.departures.edges.length > 0
            ? data.template.departures.edges.map(removeGQLTypename)
            : [];
        this.slabs =
          data.template.slabs.edges && data.template.slabs.edges.length > 0
            ? data.template.slabs.edges.map(removeGQLTypename).map((slab) => ({
                ...slab,
                items: slab.items.edges
                  ? slab.items.edges.map(removeGQLTypename)
                  : [],
              }))
            : [];
      },
      skip() {
        return this.id == "" || this.skipLoad;
      },
      fetchPolicy: "network-only",
    },
  },
  mounted() {
    this.skipLoad = false;
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/templates/builder/GroupTemplateBuilder.vue